import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7003 2.04045C11.0908 1.64993 11.724 1.64993 12.1145 2.04045L13.9596 3.8855C14.3501 4.27602 14.3501 4.90919 13.9596 5.29971L5.82246 13.4368C5.50558 13.7537 5.09147 13.955 4.64654 14.0084L2.89329 14.2187C2.24986 14.296 1.70406 13.7502 1.78127 13.1067L1.99166 11.3535C2.04505 10.9085 2.24633 10.4944 2.5632 10.1776L10.7003 2.04045Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path d="M9.23456 3.50616L12.4938 6.76542" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
  default: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.404 2.70711C16.7945 2.31658 17.4277 2.31658 17.8182 2.70711L21.2929 6.18178C21.6834 6.57231 21.6834 7.20547 21.2929 7.596L8.4891 20.3998C8.17222 20.7166 7.75811 20.9179 7.31317 20.9713L3.70808 21.4039C3.06465 21.4811 2.51885 20.9353 2.59606 20.2919L3.02867 16.6868C3.08206 16.2419 3.28333 15.8277 3.60021 15.5109L16.404 2.70711Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M13.8519 5.25922L18.7408 10.1481" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.1077 3.37376C22.4982 2.98324 23.1314 2.98324 23.5219 3.37376L28.6262 8.47807C29.0168 8.86859 29.0168 9.50176 28.6262 9.89228L11.1558 27.3627C10.8389 27.6796 10.4248 27.8809 9.97987 27.9343L4.52292 28.5891C3.87949 28.6663 3.33369 28.1205 3.4109 27.4771L4.06574 22.0201C4.11913 21.5752 4.3204 21.1611 4.63728 20.8442L22.1077 3.37376Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M18.4692 7.01227L24.9877 13.5308" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
};

function EditIcon(props: SvgIconProps) {
  const item = size[(props.fontSize as "small" | "large") || "default"];

  return <SvgIcon {...props}>{item}</SvgIcon>;
}

export default EditIcon;
